export default __webpack_public_path__ + "static/media/Art-Right.9ca0b8f6.png";